module.exports = __webpack_public_path__ + "static/g3_intro-05675c53dd3ead1e52c4d1e6877b74d1.jpg";